import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Camera, X } from "lucide-react";

// Camera scanning via the browser. Capacitor: swap for a native barcode scanner plugin with the same onScan contract.
export function QrScanner({ onScan, label = "Scan with camera", testId }: { onScan: (text: string) => void; label?: string; testId: string }) {
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState("");
  const ref = useRef<Html5Qrcode | null>(null);
  const id = `${testId}-region`;

  useEffect(() => {
    if (!open) return undefined;
    const scanner = new Html5Qrcode(id);
    ref.current = scanner;
    scanner.start({ facingMode: "environment" }, { fps: 10, qrbox: 240 }, (text) => {
      onScan(text);
      setOpen(false);
    }, () => {}).catch(() => setErr("Camera unavailable or permission denied. Type the code instead."));
    return () => { scanner.isScanning && scanner.stop().catch(() => {}); };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="space-y-2">
      {!open ? (
        <button type="button" className="fp-btn-secondary w-full" onClick={() => { setErr(""); setOpen(true); }} data-testid={`${testId}-open`}>
          <Camera size={16} /> {label}
        </button>
      ) : (
        <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-black">
          <div id={id} className="w-full" />
          <button type="button" aria-label="Close scanner" onClick={() => setOpen(false)} className="absolute right-2 top-2 rounded-full bg-white p-2" data-testid={`${testId}-close`}><X size={16} /></button>
        </div>
      )}
      {err && <p className="text-xs text-amber-800" data-testid={`${testId}-error`}>{err}</p>}
    </div>
  );
}
